/**
 * Shared column layout for the Meaning page's desktop redesign (design bundle screens 13a/13b).
 * The header and the body row both use this so the logo/nav/search line up pixel-for-pixel with
 * the This week panel, the feed cards, and the Live mentions panel beneath them.
 *
 * Ratio: 348fr (aside) : 668fr (feed) : 348fr (aside) — the feed card renders at exactly 632px wide
 * at the max-width below (matching the design), with each aside exactly half that (316px).
 */
export const MEANING_GRID_COLS_CLASS = 'grid-cols-[348fr_668fr_348fr]';
export const MEANING_ROW_MAX_WIDTH_CLASS = 'max-w-[1364px]';

/**
 * Reference width for the card-detail view's left edge only (see MeaningDesktopDetailShell): the
 * left side keeps the offset this width's centering would give it — This week/Tags doesn't move —
 * while the right side is pinned to a fixed gap instead of scaling with the window.
 */
export const MEANING_DETAIL_LEFT_REFERENCE_WIDTH = 1600;
